module.exports = __webpack_public_path__ + "static/media/auracofre.64cba759.png";